/**
 * 一个空的方法，始终返回 undefined，可用于初始化值
 */
function noop () {}

module.exports = noop



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/noop.js
// module id = enXr
// module chunks = 141